import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "@appcore/_guards/auth.guard";
import { EmailValidationComponent } from "@appcore/components/emailValidation/emailValidation.component";
import { CallbackComponent } from "./callback.component";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./login";
import { LogoutComponent } from "./logout";
import { MessagesComponent } from "./messages/messages.component";

@NgModule({
	imports: [
		RouterModule.forRoot(
			[
				{ path: "", component: HomeComponent },
				{
					path: "admin",
					loadChildren: () =>
						import("./components/administration/administration.module").then(m => m.AdministrationModule),
					canActivate: [AuthGuard]
				},
				{
					path: "catalog",
					loadChildren: () => import("./components/catalog/catalog.module").then(m => m.CatalogModule),
					canActivate: [AuthGuard]
				},
				{
					path: "client",
					loadChildren: () => import("./components/client/client.module").then(m => m.ClientModule),
					canActivate: [AuthGuard]
				},
				{
					path: "insights",
					loadChildren: () => import("./components/insights/insights.module").then(m => m.InsightsModule),
					canActivate: [AuthGuard]
				},
				{
					path: "support",
					loadChildren: () => import("./components/support/support.module").then(m => m.SupportModule),
					canActivate: [AuthGuard]
				},
				{
					path: "system",
					loadChildren: () => import("./components/system/system.module").then(m => m.SystemModule),
					canActivate: [AuthGuard]
				},
				{ path: "email/validate/:key", component: EmailValidationComponent },
				{ path: "login/callback", component: CallbackComponent, pathMatch: "full" },
				{ path: "login", component: LoginComponent, pathMatch: "full" },
				{ path: "logout", component: LogoutComponent, pathMatch: "full" },
				{ path: "messages", component: MessagesComponent, canActivate: [AuthGuard] },
				{ path: "**", redirectTo: "404" },
				{
					path: "404",
					loadChildren: () => import("./components/notfound/notfound.module").then(m => m.NotFoundModule)
				}
			],
			{ scrollPositionRestoration: "enabled", useHash: false }
		)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
